import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { userAPI, courseAPI, enrollmentAPI, certificateAPI } from '../../services/api';
import { LoadingSpinner } from '../../components/UI';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [pending, setPending] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [users, courses, enrollments, certs] = await Promise.all([
          userAPI.list(),
          courseAPI.list(),
          enrollmentAPI.all(),
          certificateAPI.all(),
        ]);
        setStats({
          users: users.data.length,
          students: users.data.filter((u) => u.role === 'user').length,
          trainers: users.data.filter((u) => u.role === 'trainer').length,
          courses: courses.data.length,
          enrollments: enrollments.data.length,
          pending: enrollments.data.filter((e) => e.status === 'pending').length,
          certificates: certs.data.length,
        });
        setPending(enrollments.data.filter((e) => e.status === 'pending').slice(0, 5));
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  if (!stats) return <LoadingSpinner />;

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1>Admin Dashboard</h1>
          <p className="subtitle">Overview of platform activity</p>
        </div>
      </div>

      <div className="grid grid-4">
        <div className="stat-card">
          <div className="accent-bar"></div>
          <div className="label">Total Users</div>
          <div className="value">{stats.users}</div>
          <small className="text-muted">{stats.students} students · {stats.trainers} trainers</small>
        </div>
        <div className="stat-card">
          <div className="accent-bar" style={{ background: 'var(--accent)' }}></div>
          <div className="label">Courses</div>
          <div className="value">{stats.courses}</div>
        </div>
        <div className="stat-card">
          <div className="accent-bar" style={{ background: 'var(--warning)' }}></div>
          <div className="label">Pending Enrollments</div>
          <div className="value">{stats.pending}</div>
          <small className="text-muted">of {stats.enrollments} total</small>
        </div>
        <div className="stat-card">
          <div className="accent-bar" style={{ background: 'var(--success)' }}></div>
          <div className="label">Certificates Issued</div>
          <div className="value">{stats.certificates}</div>
        </div>
      </div>

      <div className="mt-3">
        <div className="flex justify-between items-center mb-2">
          <h3>Pending approvals</h3>
          <Link to="/admin/enrollments" className="btn btn-secondary btn-sm">View all</Link>
        </div>
        {pending.length === 0 ? (
          <div className="card text-center text-muted">No pending enrollments 🎉</div>
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Student</th>
                  <th>Course</th>
                  <th>Enrolled</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {pending.map((e) => (
                  <tr key={e._id}>
                    <td>
                      <strong>{e.user?.name}</strong>
                      <div className="text-muted" style={{ fontSize: '0.8rem' }}>{e.user?.email}</div>
                    </td>
                    <td>{e.course?.title}</td>
                    <td>{new Date(e.createdAt).toLocaleDateString()}</td>
                    <td>
                      <Link to="/admin/enrollments" className="btn btn-secondary btn-sm">Review</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
